import React, { useEffect, useState } from 'react'

import { GetWhatsNewItem } from '../../../../store/ContentfulClient'

import WhatsNewShowSidebar from './components/WhatsNewShowSidebar'
import WhatsNewItem from './components/WhatsNewItem'

import { Sidebar, MainContent } from '../../../../layouts/components/Structure'

const WhatsNewShow = ({ match }) => {
    const [loading, setLoading] = useState(true)
    const [whatsNewItem, setWhatsNewItem] = useState(null)

    useEffect(() => {
        const {
            params: { slug }
        } = match

        setLoading(true)
        GetWhatsNewItem(slug).then(item => {
            setWhatsNewItem(item)
            setLoading(false)
        })
    }, [match])

    if (!whatsNewItem) {
        return null
    }

    const {
        fields: { relatedNews }
    } = whatsNewItem

    return (
        <>
            <Sidebar>{loading ? null : <WhatsNewShowSidebar relatedItems={relatedNews} />}</Sidebar>
            <MainContent>
                {loading ? <p>Loading</p> : <WhatsNewItem whatsNewItem={whatsNewItem} />}
            </MainContent>
        </>
    )
}

export default WhatsNewShow
